import qs from "qs";

const url = "/quotation-workflow-maintain";

export const quotationWorkflowMaintainController = {
  searchQuotationWorkflowSetting: (vueInstance, groupCodeList, unpaged, page, size, sort) => {
    return vueInstance.$quotationHttp
      .get(`${url}/quotation-workflow-setting/search`, {
        params: { groupCodeList, unpaged, page, size },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
      });
  },
  downloadQuotationWorkflowSetting: (vueInstance, groupCodeList) => {
    return vueInstance.$quotationHttp
      .get(`${url}/quotation-workflow-setting/download`, {
        params: { groupCodeList },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
        responseType: "blob"
      });
  },
  uploadQuotationWorkflowSetting: (vueInstance, formData) => {
    return vueInstance.$quotationHttp
      .post(`${url}/quotation-workflow-setting/upload`, formData);
  },
  deleteQuotationWorkflowSetting: (vueInstance, uuidList) => {
    return vueInstance.$quotationHttp
      .delete(`${url}/quotation-workflow-setting/uuid`, {
        params: { uuidList },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      });
  }
};
